import { z } from 'zod';

/**
 * Отключает JIT-компиляцию схем Zod (AI-91).
 *
 * Zod 4 по умолчанию собирает быстрый парсер объектов через `new Function()`.
 * Перед этим он делает feature-detect — `new Function('')` в `try/catch`, —
 * который под CSP считается нарушением `script-src` и требует `'unsafe-eval'`.
 *
 * Добавлять `'unsafe-eval'` ради этого нельзя: директива открывает главный
 * путь эскалации XSS. Функционально Zod и без JIT работает — при блокировке
 * он ловит ошибку и уходит на интерпретируемый парсинг, — но каждая загрузка
 * чанка со схемами всё равно порождает violation-репорт. Флаг `jitless`
 * отключает саму пробу: JIT-ветка отсекается до обращения к `new Function()`.
 *
 * Цена — более медленный парсинг объектов. На объёмах валидации форм
 * (единицы полей на сабмит) это незаметно.
 *
 * Модуль импортируется первым в `src/index.tsx`: конфиг должен примениться
 * до создания первой схемы, иначе feature-detect успеет сработать.
 *
 * @see .ai/rules/security/csp.md
 */
z.config({ jitless: true });
